import { isHostnameError } from 'SharedHelpers/error';
import useTranslate from 'Hooks/useTranslate';
import { instanceOfValidationError } from 'Interfaces/Api';

interface SubmitInfoInterface {
    isLastStep: boolean;
    isMultiStep: boolean;
    redirectUrl: string;
    showLogin: boolean;
}

interface CallbacksInterface {
    setError: Function;
    setIsLoading: Function;
}

interface ErrorHandlerHook {
    errorHandler: (submitInfo: SubmitInfoInterface, data: any, callbacks: CallbacksInterface) => void;
}

export const useErrorHandler = (): ErrorHandlerHook => {
    const { tPlain } = useTranslate();
    const GENERIC_ERROR_MSG = tPlain('signupOverlay_generic error message');

    const errorHandler = (submitInfo: SubmitInfoInterface, errors: any, callbacks: CallbacksInterface) => {
        const { setError, setIsLoading } = callbacks;
        const { isLastStep, isMultiStep } = submitInfo;
        if (!instanceOfValidationError(errors)) {
            const errorField = isMultiStep && isLastStep ? 'subscribe' : 'email';
            setError(errorField, {
                type: 'custom',
                message: GENERIC_ERROR_MSG,
            });
        } else {
            Object.entries(errors).forEach(([key, message]) => {
                if (!message) {
                    return;
                }
                const displayMessage = isHostnameError(message as string | string[]) ? GENERIC_ERROR_MSG : message;
                setError(key, {
                    type: 'custom',
                    message: displayMessage,
                });
            });
        }

        setIsLoading(false);
    };

    return {
        errorHandler,
    };
};
